import { ActionsObservable } from 'redux-observable';
import { Store } from 'redux';
import { Observable } from 'rxjs';
import _ from 'lodash';
import { EmptyObservable } from 'rxjs/observable/EmptyObservable';
import * as Sentry from '@sentry/react';

import { FETCH_ALL_LOCATIONS } from './constants';
import { FetchAllLocationsAction } from './actions';
import { selectLocations } from './selectors';
import LocationApi from './api';

const fetchAllLocations = (action$: ActionsObservable<FetchAllLocationsAction>, store: Store) =>
  action$.ofType(FETCH_ALL_LOCATIONS).mergeMap(() => {
    const state = store.getState();

    const actions = [];

    const locations = selectLocations(state);

    if (locations.size === 0) {
      actions.push(LocationApi.fetchAll());
    }

    if (actions.length === 0) {
      return new EmptyObservable();
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions)])
      .catch((error) => {
        Sentry.captureException(error);
        return new EmptyObservable();
      });
  });

export default [fetchAllLocations];
